import React, { Component } from 'react'
import get from 'lodash/get'
import { contentPropTypes, routerPropTypes } from 'Types'
import PropTypes from 'prop-types'
import { RelatedInstalooksList, ProductGrid } from '../components'

import skins from '../skins'
import { skin } from 'Utils'

class Large extends Component {
  render() {
    const { params, className, location, screenType, data } = this.props

    // TODO: this should be in theme/layout
    const isSmallScreen = screenType === 'small'
    const relatedInstalooksImageWidth = isSmallScreen ? '400' : '100'
    const relatedInstalooksImageHeight = isSmallScreen ? '' : '100'
    const relatedInstalooksImageCrop = isSmallScreen ? 'scale' : 'fill'
    const cloudinaryProps = {
      width: relatedInstalooksImageWidth,
      height: relatedInstalooksImageHeight,
      crop: relatedInstalooksImageCrop
    }

    function createMarkup(content) {
      return { __html: content }
    }

    const instalook = data.content
    const { title, layout } = instalook

    let instalookCategory = get(data.content, 'theme', '')
    const instalookInfo = get(layout, 'intros[0].data', '')
    const imageBy = get(layout, 'images[0].data.credit', 'Shareight')
    const embed = get(layout, 'embeds[0].data', [])

    return (
      <div className={`main-container ${className}`}>
        <div className="main-wrapper">
          <div className="main-wrapper__column-wrap">
            <div className="main-column">
              <div className="main-column__category">{instalookCategory}</div>
              <h1 className="main-column__instalook-title">{title.long}</h1>
              <div
                className="main-column__embed"
                dangerouslySetInnerHTML={createMarkup(embed)}
              />
              {imageBy && (
                <div className="main-column__instalook-imageBy">
                  Image by: {imageBy}
                </div>
              )}
              <div className="main-column__instalook-intro">
                {instalookInfo}
              </div>
              <span className="line-break" />
            </div>
          </div>
          <ProductGrid products={layout.collections[0].preview.products} />
          <RelatedInstalooksList
            location={location}
            params={params}
            {...cloudinaryProps}
          />
        </div>
      </div>
    )
  }
}

Large.propTypes = {
  className: PropTypes.string,
  screenType: PropTypes.string,
  data: PropTypes.shape({
    content: PropTypes.shape({ ...contentPropTypes })
  }),
  ...routerPropTypes
}

export default skin(Large, skins)
